import { lazyLoadOnRender } from '@ms/yammer-libs-lazy';

const MediaLightboxErrorBoundary = () =>
  import(/* webpackChunkName: "4-feat-medialightbox" */ './MediaLightboxErrorBoundary');

export default lazyLoadOnRender({ loader: MediaLightboxErrorBoundary });
